<template>
  <div>
    <div class="step" v-for="(item, index) in shop" :key="index">
      <span class="title">{{ item.title }}</span>
      <span v-html="item.text" class="text"></span>
      <el-image v-if="item.url" style="width: 400px;" :src="item.url" :preview-src-list="[item.url]"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shop: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.step {
  display: flex;
  flex-direction: column;
  position: relative;
  .title {
    font-size: 16px;
    padding-left: 10px;
    margin-top: 10px;
    font-weight: normal;
  }
  .text {
    font-size: 16px;
    padding-left: 10px;
    margin-top: 10px;
    font-weight: normal;
  }
  .index {
    position: absolute;
    border: 1px solid black;
    background: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    line-height: 40px;
    right: 10px;
    z-index: 100;
  }
  .border {
    z-index: 10;
    position: absolute;
    width: 2px;
    background: black;
    top: 0px;
    bottom: 0px;
    right: 30px;
  }
}
</style>
